import ReferralManagementIcon from "../../assets/images/sidebar/referral_management.svg";

const referralManagementModule = {
  name: "Referral Management",
  key: "referral_management",
  imgSrc: ReferralManagementIcon,
  submodules: [
    {
      name: "Referral Dashboard",
      key: "referral_dashboard",
      defaultExpanded: false,
      features: [
        {
          key: "referral_dashboard",
          name: "Referral Dashboard",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_referrers_details",
              name: "View Referrer's Details",
              defaultEnabled: true,
              description: "Show referrer profiles and statistics"
            },
            {
              key: "view_referrers_withdraw_requests",
              name: "View Referrer's Withdraw Requests",
              defaultEnabled: false,
              description: "Display withdrawal requests from referrers"
            },
            {
              key: "change_accept_reject_hold_status_of_referrer",
              name: "Change Accept / Reject / Hold Status of Referrer",
              defaultEnabled: false,
              description: "Update referrer account status"
            }
          ]
        }
      ]
    },
    {
      name: "Client Referral Management",
      key: "client_referral_management",
      defaultExpanded: false,
      features: [
        {
          key: "referral_list",
          name: "Referral List",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_referral_list",
              name: "View Referral List",
              defaultEnabled: true,
              description: "Show all referral records"
            },
            {
              key: "view_customers_details",
              name: "View Customer's Details",
              defaultEnabled: false,
              description: "View referred customer information"
            },
            {
              key: "accept_the_referrers_requested_amount",
              name: "Accept the Referrer's Requested Amount",
              defaultEnabled: false,
              description: "Approve referrer payout request"
            },
            {
              key: "reject_the_referrers_requested_amount",
              name: "Reject the Referrer's Requested Amount",
              defaultEnabled: false,
              description: "Reject referrer payout request"
            },
            {
              key: "hold_the_referrers_requested_amount",
              name: "Hold the Referrer's Requested Amount",
              defaultEnabled: false,
              description: "Put referrer payout request on hold"
            },
          ]
        }
      ]
    }
  ]
};

export default referralManagementModule;
